/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment, useRef } from 'react'

import { Dialog, Transition } from '@headlessui/react'
import { ExclamationCircleIcon } from '@heroicons/react/outline'
import { closeErrorModal } from '@store/ducks/modal'
import { useAppDispatch, useAppSelector } from '@store/hooks'

const styles = {
	dialog: 'relative z-10',
	background:
		'fixed inset-0 bg-black-transparent bg-opacity-75 transition-opacity',
	container: 'fixed z-10 inset-0 overflow-y-auto',
	subContainer:
		'flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0',
	span: 'hidden sm:inline-block sm:align-middle sm:h-screen',
	box: 'relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6',
	boxContainer: 'sm:flex sm:items-start',
	header:
		'mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10',
	icon: 'h-6 w-6 text-red-600',
	content: 'mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left',
	title: 'text-lg leading-6 font-medium text-gray-900',
	messageContainer: 'mt-2',
	message: 'text-sm text-gray-500',
	footer: 'mt-5 sm:mt-4 sm:ml-10 sm:pl-4 sm:flex',
	actionButton:
		'inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:w-auto sm:text-sm',
	cancelButton:
		'mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-white text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm',
}

export default function Error() {
	const dispatch = useAppDispatch()
	const { options } = useAppSelector((state) => state.modal)

	const cancelButtonRef = useRef(null)

	return (
		<Transition.Root show={options?.type === 'error'} as={Fragment}>
			<Dialog
				as='div'
				className={styles.dialog}
				initialFocus={cancelButtonRef}
				onClose={() => {
					dispatch(closeErrorModal())
					options?.onClick && options?.onClick()
				}}
			>
				<Transition.Child
					as={Fragment}
					enter='ease-out duration-300'
					enterFrom='opacity-0'
					enterTo='opacity-100'
					leave='ease-in duration-200'
					leaveFrom='opacity-100'
					leaveTo='opacity-0'
				>
					<div className={styles.background} />
				</Transition.Child>

				<div className={styles.container}>
					<div className={styles.subContainer}>
						<span className={styles.span} aria-hidden='true'>
							&#8203;
						</span>
						<Transition.Child
							as={Fragment}
							enter='ease-out duration-300'
							enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
							enterTo='opacity-100 translate-y-0 sm:scale-100'
							leave='ease-in duration-200'
							leaveFrom='opacity-100 translate-y-0 sm:scale-100'
							leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
						>
							<Dialog.Panel className={styles.box}>
								<div className={styles.boxContainer}>
									<div className={styles.header}>
										<ExclamationCircleIcon
											className={styles.icon}
											aria-hidden='true'
										/>
									</div>

									<div className={styles.content}>
										<Dialog.Title as='h3' className={styles.title}>
											{options?.title}
										</Dialog.Title>
										<div className={styles.messageContainer}>
											<p className={styles.message}>{options?.message}</p>
										</div>
									</div>
								</div>

								<div className={styles.footer}>
									<button
										type='button'
										className={styles.actionButton}
										onClick={() => {
											options?.onClick && options?.onClick()

											dispatch(closeErrorModal())
										}}
									>
										{options?.buttonLabel || 'Fechar'}
									</button>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	)
}
